import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { Card, CardBody, Col, Container, Row } from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"

const Dashboard = props => {
  //meta title
  document.title = props.t("Dashboard | SAR")

  return (
    <React.Fragment>
      <div className="page-content dashboard_page">
        <Container fluid></Container>
      </div>
    </React.Fragment>
  )
}

// Dashboard.propTypes = {
//   t: PropTypes.any,
//   chartsData: PropTypes.any,
//   onGetChartsData: PropTypes.func,
// }

export default withTranslation()(Dashboard)
